var _path, _path2, _circle, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 57,
    viewBox: "0 0 34 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.9565 45.7826H2",
    stroke: "#222222",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9784 49.8152C17.1312 49.8152 17.2777 49.8759 17.3858 49.9839C17.4938 50.092 17.5545 50.2385 17.5545 50.3913C17.5545 50.5441 17.4938 50.6906 17.3858 50.7986C17.2777 50.9067 17.1312 50.9674 16.9784 50.9674C16.8256 50.9674 16.6791 50.9067 16.5711 50.7986C16.463 50.6906 16.4023 50.5441 16.4023 50.3913C16.4023 50.2385 16.463 50.092 16.5711 49.9839C16.6791 49.8759 16.8256 49.8152 16.9784 49.8152Z",
    stroke: "#222222",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.9783,
    cy: 49.8152,
    r: 1.15217,
    fill: "#222222"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3478 2H6.6087C4.06338 2 2 4.06338 2 6.6087V50.3913C2 52.9366 4.06338 55 6.6087 55H27.3478C29.8931 55 31.9565 52.9366 31.9565 50.3913V6.6087C31.9565 4.06338 29.8931 2 27.3478 2Z",
    stroke: "#222222",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/PhoneIcon.2d6343086159e605ae424db0f0fa0df5.svg";
export { ForwardRef as ReactComponent };